<template lang="pug">
  .product-media-gallery
    .product-media-gallery__media-wrapper(
      v-for="(media, index) in product.media.slice(1, 2)", :key="index"
    )
      media.product-media-gallery__media(:media="media" :aspect-ratio="aspectRatio" :id="`gallery-media-${index}`")
</template>

<script>
  import Media from 'scripts/components/basic/Media.vue';
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';
  import Icon from 'scripts/components/basic/Icon.vue';

  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { scrollToElement } from 'scripts/helpers/util.js';

  export default {
    name: 'ProductMediaGallery',
    components: {
      Media,
      BaseButton,
      swiper,
      swiperSlide,
      Icon,
    },
    props: {
      product: Object,
    },
    data() {
      return {
        visibleThumbnailCount: 5,
        activeThumbnail: 0,
        slideIndex: 0,
        aspectRatio: 1,
        swiperOptions: {
          navigation: {
            nextEl: '.product-media-gallery__slide-button--right',
            prevEl: '.product-media-gallery__slide-button--left',
          },
        },
      };
    },
    computed: {
      productBadge() {
        if (!this.product || !this.product.customFields.badge) return false;

        return this.product.customFields.badge[0];
      },
      images() {
        return this.product.media.filter((media) => {
          return media.media_type === 'image';
        });
      },
      swiper() {
        return this.$refs.galleryCarousel;
      },
    },
    methods: {
      scrollToMedia(index, event) {
        event.preventDefault();
        this.activeThumbnail = index;
        scrollToElement(`gallery-media-${index}`);
      },
      showMoreThumbnails() {
        this.visibleThumbnailCount += this.hiddenThumbnailCount;
      },
      slidePrev() {
        this.swiper.swiper.slidePrev();
        this.slideIndex = this.swiper.swiper.activeIndex;
      },
      slideNext() {
        this.swiper.swiper.slideNext();
        this.slideIndex = this.swiper.swiper.activeIndex;
      },
    },
  };
</script>

<style lang="scss">
  .product-media-gallery {
    z-index: index($layout, 'page-layout-content');

    @include mobile-only {
      position: relative;
      margin: 0 auto;
      width: 100%;
    }
  }

  .product-media-gallery__thumbnails {
    @include tablet-up {
      position: sticky;
      top: $desktop-nav-height;
      width: 170px;
      padding: 0 $spacing-unit * 13;
    }
  }

  .product-media-gallery__thumbnail {
    display: block;
    margin: 0 auto ($spacing-unit * 2);
    min-width: 60px;
    height: 70px;
    object-fit: cover;
  }

  .product-media-gallery__thumbnail--active {
    border: 1px solid $color-black;
  }

  .product-media-gallery__more-thumbnails {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: rem(14);
    line-height: rem(18);
    width: 100%;
    height: 34px;
    background-color: transparent;
    border: 1px solid $color-black;
    cursor: pointer;
  }

  .product-media-gallery__media-container {
    @include tablet-up {
      flex: 1;
    }
  }

  .product-media-gallery__media-wrapper {
    @include tablet-up {
      margin-bottom: $spacing-unit * 5;
    }
  }

  .product-media-gallery__media {
    @include tablet-up {
      width: 100%;
    }
  }

  .product-media-gallery__badge {
    display: inline-block;
    position: absolute;
    top: $spacing-unit;
    right: $spacing-unit;
    z-index: index($product-media-gallery, 'badge');
  }

  .product-media-gallery__badge-image {
    width: $spacing-unit * 29;
    height: auto;
  }

  .product-media-gallery__slide-count {
    position: absolute;
    bottom: 0px;
    left: 10px;
    z-index: 1;
  }

  .product-media-gallery__slide-buttons {
    position: absolute;
    bottom: 0px;
    right: 10px;
    display: flex;
    z-index: 1;

    .icon {
      fill: $color-black;
    }
  }

  .product-media-gallery__slide-button--left {
    margin-right: 10px;
  }
</style>
